(function () {
    const header = document.querySelector('[data-newsapi-header]');
    if (!header) return;

    const mobileQuery = window.matchMedia('(max-width: 992px)');
    const menu = header.querySelector('.gh-head-menu');
    const menuToggle = header.querySelector('.newsapi-menu-toggle');
    const menuClose = header.querySelector('.newsapi-menu-close');
    const dropdownItems = Array.from(header.querySelectorAll('[data-newsapi-dropdown]'));
    const demoLinks = Array.from(document.querySelectorAll('[data-newsapi-demo]'));
    let closeTimer;
    let calendlyLoader;
    let mobileScrollPosition = 0;

    const loadCalendly = function () {
        if (window.Calendly) return Promise.resolve(window.Calendly);
        if (calendlyLoader) return calendlyLoader;

        calendlyLoader = new Promise(function (resolve, reject) {
            const stylesheet = document.createElement('link');
            const script = document.createElement('script');

            stylesheet.rel = 'stylesheet';
            stylesheet.href = 'https://assets.calendly.com/assets/external/widget.css';
            document.head.appendChild(stylesheet);

            script.src = 'https://assets.calendly.com/assets/external/widget.js';
            script.async = true;
            script.onload = function () {
                resolve(window.Calendly);
            };
            script.onerror = reject;
            document.head.appendChild(script);
        });

        return calendlyLoader;
    };

    const closeDropdowns = function (except) {
        dropdownItems.forEach(function (item) {
            if (item === except) return;
            item.classList.remove('is-open');
            item.querySelector('.newsapi-dropdown-toggle').setAttribute('aria-expanded', 'false');
        });
    };

    const setDropdown = function (item, open) {
        if (mobileQuery.matches) return;
        window.clearTimeout(closeTimer);
        closeDropdowns(open ? item : null);
        item.classList.toggle('is-open', open);
        item.querySelector('.newsapi-dropdown-toggle').setAttribute('aria-expanded', String(open));
    };

    const setMobileMenu = function (open, moveFocus) {
        const wasOpen = document.body.classList.contains('newsapi-nav-open');

        if (open && !wasOpen) {
            mobileScrollPosition = window.scrollY;
        }

        document.body.classList.toggle('newsapi-nav-open', open);
        menuToggle.setAttribute('aria-expanded', String(open));

        if (!open && wasOpen) {
            window.scrollTo(0, mobileScrollPosition);
        }

        if (open) {
            if (moveFocus !== false) {
                menuClose.focus();
            } else {
                menuToggle.blur();
            }
        } else if (moveFocus !== false) {
            menuToggle.focus();
        }
    };

    dropdownItems.forEach(function (item) {
        const toggle = item.querySelector('.newsapi-dropdown-toggle');
        let wasOpenOnPointerDown = false;

        item.addEventListener('mouseenter', function () {
            setDropdown(item, true);
        });

        item.addEventListener('mouseleave', function () {
            closeTimer = window.setTimeout(function () {
                setDropdown(item, false);
            }, 100);
        });

        item.addEventListener('focusin', function () {
            setDropdown(item, true);
        });

        item.addEventListener('focusout', function () {
            window.setTimeout(function () {
                if (!item.contains(document.activeElement)) {
                    setDropdown(item, false);
                }
            }, 0);
        });

        toggle.addEventListener('pointerdown', function () {
            wasOpenOnPointerDown = item.classList.contains('is-open');
        });

        toggle.addEventListener('click', function (event) {
            const wasOpen = event.detail === 0
                ? item.classList.contains('is-open')
                : wasOpenOnPointerDown;

            setDropdown(item, !wasOpen);
        });
    });

    menuToggle.addEventListener('click', function (event) {
        setMobileMenu(true, event.detail === 0);
    });

    menuClose.addEventListener('click', function () {
        setMobileMenu(false);
    });

    menu.addEventListener('click', function (event) {
        if (event.target === menu) {
            setMobileMenu(false);
        }
    });

    document.addEventListener('click', function (event) {
        if (!mobileQuery.matches && !header.contains(event.target)) {
            closeDropdowns();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;

        if (document.body.classList.contains('newsapi-nav-open')) {
            setMobileMenu(false);
        } else {
            closeDropdowns();
        }
    });

    const handleBreakpointChange = function () {
        closeDropdowns();
        setMobileMenu(false, false);
    };

    if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', handleBreakpointChange);
    } else {
        mobileQuery.addListener(handleBreakpointChange);
    }

    demoLinks.forEach(function (demoLink) {
        demoLink.addEventListener('click', function (event) {
            event.preventDefault();
            setMobileMenu(false);

            loadCalendly().then(function (calendly) {
                calendly.showPopupWidget(demoLink.href);
            }).catch(function () {
                window.location.href = demoLink.href;
            });
        });
    });
})();
